import { styled } from '@mui/material/styles'
import { Divider, Link, Typography } from '@mui/material'
import { mobile } from '../../utils/breakpoints'

// --------- Link  Text ------------------------------------------
export const LinkText = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{ textColor?: string }>`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  color: ${({ theme, textColor }) => textColor ?? theme.palette.secondary.main};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.palette.secondary.dark};
  }

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '15px',
    })}
`

// --------- Link Contrast Text ------------------------------------------
export const LinkContrastText = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{ textColor?: string }>`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  color: ${({ theme, textColor }) => textColor ?? theme.palette.primary.contrastText};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.palette.secondary.dark};
  }

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '15px',
    })}
`

// --------- Small Link Contrast Text ------------------------------------------
export const SmallLinkContrastText = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{ textColor?: string }>`
  font-size: 15px;
  font-weight: ${({ theme }) => theme.typography.fontWeightLight};
  color: ${({ theme, textColor }) => textColor ?? theme.palette.primary.contrastText};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.palette.secondary.dark};
  }

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '10px',
    })}
`

// --------- Text ------------------------------------------
export const Text = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{ textColor?: string }>`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  color: ${({ theme, textColor }) => textColor ?? theme.palette.text.primary};

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '15px',
    })}
`

// --------- Primary Text ------------------------------------------
export const PrimaryText = styled(Text)`
  color: ${({ theme }) => theme.palette.primary.main};
`

// --------- Text Bold ------------------------------------------
export const TextBold = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{ textColor?: string }>`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  color: ${({ theme, textColor }) => textColor ?? theme.palette.text.primary};

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '15px',
    })}
`

// --------- Small Text ------------------------------------------
export const SmallText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{ textColor?: string }>`
  font-size: 15px;
  font-weight: ${({ theme }) => theme.typography.fontWeightLight};
  color: ${({ theme, textColor }) => textColor ?? theme.palette.text.primary};

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '12px',
    })}
`

// --------- Title Text ------------------------------------------
export const TitleText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{ textColor?: string }>`
  font-size: 22px;
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  color: ${({ theme, textColor }) => textColor ?? theme.palette.text.primary};

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '17px',
    })}
`

// --------- Big Title Text ------------------------------------------
export const BigTitleText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{ textColor?: string }>`
  font-size: 45px;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  color: ${({ theme, textColor }) => textColor ?? theme.palette.text.primary};

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '35px',
    })}
`

// --------- Tooltip Text ------------------------------------------
export const TooltipText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'textColor',
})<{ textColor?: string }>`
  font-size: 16px;
  white-space: nowrap;
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '18px',
    })}
`

// --------- Separator ------------------------------------------
export const Separator = styled(Divider)<{ component?: React.ElementType }>`
  background-color: ${({ theme }) => theme.palette.text.secondary};
  width: 2px;
  margin: 5px 0;

  ${({ theme }) =>
    mobile(theme, {
      margin: '2px 0',
    })}
`
